import resolveEntityBreadcrumbLabel from '../../../helpers/resolveEntityBreadcrumbLabel';
import type { ResolvePlaybookStepBreadcrumbLabelParams } from '../types';

const resolvePlaybookStepBreadcrumbLabel = ({
    stepId,
    stepName,
    isLoadingStep,
}: ResolvePlaybookStepBreadcrumbLabelParams): string =>
    resolveEntityBreadcrumbLabel({
        entityId: stepId,
        entityName: stepName,
        isLoading: isLoadingStep,
        entityKindLabel: 'Step',
    });

export default resolvePlaybookStepBreadcrumbLabel;
